import React, { useEffect, useMemo, useRef, useState } from 'react';
import logo from '../../../assets/logos/new_logo_black_3.png';
import english from '../../../assets/website/images/english.png';
import japanese from '../../../assets/website/images/japanese.png';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { getLocalKey, setLocalKey } from '../../../utils/commonfunction';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { CMSOptions } from '../services/website.services';
import { MENU_LOCATION } from '../../../utils/Constants';

function WebsiteHeader() {
  const { t } = useTranslation();
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const [refreshOptionsAPI, setRefreshOptionsAPI] = useState(false);
  const [flag, setFlag] = useState(getLocalKey("system_language_flag") || english);
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const menuRef = useRef(null);
  const menuToggleRef = useRef(null);
  const loginRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if ((menuOpen && (menuRef.current?.contains(event.target) || menuToggleRef.current?.contains(event.target)))
        || (loginOpen && loginRef.current?.contains(event.target))) {
        return;
      }
      setMenuOpen(false);
      setLoginOpen(false);
    };

    document.addEventListener("pointerdown", closeMenuOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeMenuOnOutsideClick);
  }, [loginOpen, menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
    setLoginOpen(false);
  }, [location.pathname]);

  const changeLanguage = (lang, flag) => {
    i18next.changeLanguage(lang);
    setLocalKey("system_language", lang);
    setLocalKey("system_language_flag", flag);
    setFlag(flag);
    const evt = new CustomEvent("language_change");
    document.dispatchEvent(evt);
  };

  useEffect(() => {
    CMSOptions(MENU_LOCATION.menu_of_page_header).then((response) => {
      setDynamicOptions(response?.data);
    }).catch((error) => {
      console.log("error of terms&conditions", error);
    });
  }, [refreshOptionsAPI]);

  useMemo(() => {
    document.addEventListener('language_change', function () {
      setRefreshOptionsAPI(!refreshOptionsAPI);
    })
  });

  return (
    <div className='header-marketing'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container">
          <Link className="navbar-brand" to={'/'}><img src={logo} alt='' /></Link>
          <button
            ref={menuToggleRef}
            className="navbar-toggler"
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div ref={menuRef} className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`} id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} className="nav-link" to={'/'}>{t("web_nav_link_home")}</NavLink>
              </li>
              <li className="nav-item">
                <Link onClick={() => setMenuOpen(false)} className="nav-link" to="/#about_us">{t("web_nav_link_about_us")}</Link>
              </li>
              <li className="nav-item">
                <Link onClick={() => setMenuOpen(false)} className="nav-link" to="/#service_overview">{t("web_nav_link_service_overview")}</Link>
              </li>
              <li className="nav-item">
                <Link onClick={() => setMenuOpen(false)} className="nav-link" to="/#how_it_works">{t("web_nav_link_how_does_it_operate")}</Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link" to="#">{t("web_nav_link_pricing")}</Link>
              </li> */}
              <li className="nav-item">
                <Link onClick={() => setMenuOpen(false)} className={location.pathname.includes("manual-guide") ? "nav-link active" : "nav-link"} to={'/manual-guide'}>{t("web_nav_link_manual_guide")}</Link>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} className={location.pathname.includes("download") ? "nav-link active" : "nav-link"} to={'/download'}>{t("web_nav_link_download")}</NavLink>
              </li>
              {
                dynamicOptions?.map((item, i) => {
                  return (
                    <li className="nav-item" key={i}>
                      <NavLink onClick={() => setMenuOpen(false)} className="nav-link" to={`/org-info/${item?.slug}`}>{item?.title}</NavLink>
                    </li>
                  )
                })
              }

            </ul>
            <div className='header-w-right website-primary-actions d-flex align-items-center ms-auto gap-3'>
              <div className="dropdown profile-dropdown lang-dropdown ">
                <button className="dropdown-toggle website-language-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <div className='avatar avatar-xxs'>
                    <img src={flag} alt='english-flag' />
                  </div>
                  <span className="website-language-label">Language</span>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button type="button" className="dropdown-item cp" onClick={(e) => { e.preventDefault(); changeLanguage("en", english) }}>
                      <figure className='avatar avatar-xxs'>
                        <img src={english} alt='Thai-flag' />
                      </figure>
                      <span>
                        English
                      </span>
                    </button>
                  </li>
                  <li>
                    <button type="button" className="dropdown-item cp" onClick={(e) => { e.preventDefault(); changeLanguage("ja", japanese) }}>
                      <figure className='avatar avatar-xxs'>
                        <img src={japanese} alt='english-flag' />
                      </figure>
                      <span>
                        Japanese
                      </span>
                    </button>
                  </li>
                </ul>
              </div>
              <Link className="btn btn-primary" to="/#inquiry">{t("web_nav_link_inquire_now")}</Link>
            </div>
            <div className='header-w-right website-login-actions d-flex align-items-center ms-2'>
              <div ref={loginRef} className="profile-dropdown lang-dropdown website-login-dropdown">
                <button
                  className="btn btn-primary website-login-button"
                  type="button"
                  aria-expanded={loginOpen}
                  aria-haspopup="menu"
                  onClick={() => setLoginOpen((open) => !open)}
                >
                  {t("web_nav_link_login_as")}
                </button>
                {loginOpen && <ul className="dropdown-menu show website-login-menu" role="menu">
                  <li>
                    <Link
                      className="dropdown-item cp"
                      to="/restaurant/login"
                      onClick={() => setMenuOpen(false)}
                    >
                      <span>Restaurant</span>
                    </Link>
                  </li>
                   <li>
                    <Link
                      className="dropdown-item cp"
                      to="/cashier/login"
                      onClick={() => setMenuOpen(false)}
                    >
                      <span>Cashier</span>
                    </Link>
                  </li>
                </ul>}
              </div>
            </div>
          </div>
        </div>
      </nav>
      {menuOpen && <button className="website-menu-backdrop" type="button" aria-label="Close navigation menu" onClick={() => setMenuOpen(false)} />}
    </div>
  )
}

export default WebsiteHeader
